import React, { useState, useCallback } from 'react';
import { FunctionComponent } from 'react';
import { userSelectors } from '../../../../app/resource/user/user.selectors';
import { IUser } from '../../../../app/resource/user/user.types';
import { useSelectWithParams } from '../../../../utils/selector.utils';
import { useApiRequestState } from '../../../../utils/api.utils';
import useOutsideClick from '../../../../utils/click.utils';
import { IMemberSelectProps } from './types';
import Loader from 'react-loader-spinner';

export const MemberSelect: FunctionComponent<IMemberSelectProps> = ({ userIds, onMemberSelect }) => {
  const users = useSelectWithParams(userSelectors.selectResourcesById, userIds) as IUser[];
  const [open, setOpen] = useState(false);
  const [isLoading] = useApiRequestState('updateScoresBulkApi');
  const [selectedUser, setSelectedUser] = useState<IUser | null>(null);

  const close = useCallback(() => setOpen(false), [setOpen]);

  const handleClickOutside = () => {
    if (open) {
      setOpen(false);
    }
  };

  const ref = useOutsideClick(handleClickOutside);

  const handleChange = (selectedOption: IUser) => {
    if (selectedOption && selectedOption.id !== undefined) {
      onMemberSelect(selectedOption.id);
      setSelectedUser(selectedOption);
    }
    close();
  };

  return (
    <>
      <div
        ref={ref}
        className="field-container custom-select smaller-select mb-0 w280 member-select"
        style={{ margin: '0 5px' }}
      >
        <input type="hidden" />
        <span className="select-field" onClick={() => setOpen(!open)}>
          <span className="select-value">
            {selectedUser ? `${selectedUser.firstName} ${selectedUser.lastName}` : 'Select user to assign'}
          </span>
          {isLoading ? (
            <Loader type="TailSpin" color="var(--theme-primary-color)" height={20} width={20} />
          ) : (
            <i className="icon-down-dir" />
          )}
        </span>
        <div className="select-dropdown p-0" style={{ boxSizing: 'border-box', display: open ? 'block' : 'none' }}>
          {users.map((user) => (
            <div key={user.id}>
              <div
                className="select-item select-item-member p-1"
                data-val={`${user.firstName} ${user.lastName}`}
                onClick={() => handleChange(user)}
                style={{ lineHeight: '6px' }}
              >
                {`${user.firstName} ${user.lastName}`}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
